import React from 'react';
import { Typography, Box } from '@material-ui/core';
const EmptyChart = ({ show, height, text }) => {
   return (
      <div>
         {show && (
            <Box
               display={'flex'}
               height={height || '400px'}
               justifyContent={'center'}
               alignItems={'center'}
               style={{ backgroundColor: '#F2F2F2' }}
               borderRadius={'5px'}
            >
               <Typography>
                  {text || 'โปรดระบุช่วงเวลา เพื่อแสดงกราฟ'}
               </Typography>
            </Box>
         )}
      </div>
   );
};
export default EmptyChart;
